import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=3f51ef20&scoped=true&"
import script from "./CommentDetail.vue?vue&type=script&lang=js&"
export * from "./CommentDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=3f51ef20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51ef20",
  null
  
)

export default component.exports